import { CheckInLogList } from '@/features/check-in-logs';

const CheckInLogPage = () => {
  return <CheckInLogList />;
};

export default CheckInLogPage;
